/**
 * Единственный источник правды о «бессессионных» эндпоинтах аутентификации.
 *
 * На этих запросах 401 означает «эти учётные данные неверны», а не «сессия
 * протухла». Сессии там ещё нет: сбрасывать нечего, refresh делать не из чего,
 * а редирект на /login перезагружает страницу входа и уничтожает сообщение об
 * ошибке до того, как оператор его увидит.
 *
 * Ветвление именно по URL запроса, а не по window.location: форма входа может
 * жить в модалке или на другом роуте, и проверка по текущему адресу тогда
 * сломается.
 *
 * ВАЖНО: файл общий для ОБОИХ axios-инстансов (`src/api/client.ts` — тот, через
 * который реально ходит вход, и `src/shared/api/client.ts`). Вторая копия
 * списка недопустима: ровно из-за неё правка однажды легла не в тот клиент.
 *
 * `/auth/refresh` и `/auth/logout` сюда сознательно НЕ входят: там сессия есть,
 * и 401 обязан по-прежнему приводить к выходу на /login.
 */
const SESSIONLESS_AUTH_PATHS = ['/auth/login'];

export const isSessionlessAuthRequest = (url?: string): boolean => {
  if (!url) return false;
  const path = url.split('?')[0].replace(/\/+$/, '');
  return SESSIONLESS_AUTH_PATHS.some((p) => path === p || path.endsWith(p));
};
